import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";

const StopShop = ({textAlign, serviceStyle}) => {
    const { t } = useTranslation('enterprise');
const SList = [
    
    {
        image: t('lePlan.donations.imgSrc'),
        url:'/donations'
    },
    {
        image: t('lePlan.offresCSE.imgSrc'),
        url:'cse'
    },
    {
        image: t('lePlan.epargneSalariale.imgSrc'),
        url:'/employee-savings'
    },
    {
        image: t('lePlan.capital.imgSrc'),
        url:'/access-capital'
    },
]
    return (
        <div className="row row--15 service-wrapper">
              {SList.map( (val , i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <Link to={val.url}>
                            <div className={`service ${serviceStyle} ${textAlign}`} style={{background:`url(${process.env.PUBLIC_URL} ${val.image})` ,height:"400px",backgroundRepeat:"no-repeat",backgroundSize:"cover"}} >
                                <div className="content">
                                </div>
                            </div>
                        </Link>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default StopShop;